import VehicleImage from './VehicleImage';

export default VehicleImage;
